import Axios from 'axios'

const axios = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Access-Control-Allow-Origin': `${process.env.VUE_APP_API_URL}/api`,
    'access-control-allow-headers': 'Authorization',
  },
})

const getAllTimeIntervals = async () => {
  return axios.request({
    method: 'GET',
    url: '/api/time-intervals',
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const saveTimeInterval = async (data: Record<string, string>) => {
  return axios.request({
    method: 'POST',
    url: '/api/time-intervals',
    data,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const updateTimeInterval = async ({ id, ...data }) => {
  return axios.request({
    method: 'patch',
    url: `/api/time-intervals/${id}`,
    data: { id: id, ...data },
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

const deleteTimeInterval = async id => {
  return axios.request({
    method: 'DELETE',
    url: `/api/time-intervals/${id}`,
    headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
  })
}

export default {
  getAllTimeIntervals,
  saveTimeInterval,
  deleteTimeInterval,
  updateTimeInterval,
}
